<template>
    <v-text-field v:label="valueLocal.name" type="date" v-model="valueLocal.value" />
</template>

<script>
    export default {
        props: [
            'value'
        ],

        computed: {
            valueLocal: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit("input", value);
                },
            },
        }
    }
</script>
